import useEmployeeNoticesT from './useEmployeeNoticesT';

/**
 * The complete email as the recipient sees it (HLB frame included). The HTML
 * is the company's own, so it lives in a sandboxed frame — no scripts, no
 * navigation — never in the page itself.
 */
export default function EmailPreviewFrame({
  subject,
  html,
  height = 460,
  loading = false,
}) {
  const { tn } = useEmployeeNoticesT();
  return (
    <div className="grid gap-2">
      <div className="text-[13px]">
        <span className="font-bold text-zinc-700">{tn('subject')}:</span>{' '}
        {subject}
      </div>
      <iframe
        title={tn('previewEmail')}
        sandbox=""
        srcDoc={html || ''}
        style={{ height }}
        className={`w-full rounded-xl border border-zinc-200 bg-white transition-opacity ${
          loading ? 'opacity-60' : ''
        }`}
      />
    </div>
  );
}
